const REQUEST_TYPE_OPTIONS = {
  PERSON: 'Person',
  VEHICLE: 'Vehicle',
  COMPANY: 'Agency',
  AGENCY: 'Agency',
};

export default REQUEST_TYPE_OPTIONS;
